import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { IAppsettingsConfig } from '../Models/IAppsettingsConfig'
import { ICALPADSCallBackCode } from '../Models/ICALPADSCallBackCode'
import { ICALPADSToken } from '../Models/ICALPADSToken';
import { ICALPADSTables } from '../Models/ICALPADSTables';
import { ICALPADSTable14 } from '../Models/ICALPADSTable14';
import { ICALPADSTable15 } from '../Models/ICALPADSTable15';
import { ICALPADSTable17 } from '../Models/ICALPADSTable17';
import { ICALPADSUploadFile } from '../Models/ICALPADSUploadFile';
import { CALPADSFileTypeEnum } from '../Models/Enums/CALPADSFileTypeEnum';

import { ICALPADSUploadedFileDetail } from '../Models/ICALPADSUploadedFileDetail';
import { ICALPADSErrorDetailSPED } from '../Models/ICALPADSErrorDetailSPED';
import { ICALPADSErrorDetailSSRV } from '../Models/ICALPADSErrorDetailSSRV';
import { ICALPADSStatusDetail } from '../Models/ICALPADSStatusDetail';
import { ICALPADSUploadFileResponse } from '../Models/ICALPADSUploadFileResponse';

@Injectable()
export class CALPADSService extends BaseService {
  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getAppsettingsData(url: string): Observable<IAppsettingsConfig> {
    return this._http.get<IAppsettingsConfig>(url).map((response: IAppsettingsConfig) => response as IAppsettingsConfig)
      .catch(this.handleError);
  }

  CALPADSToken(codes: ICALPADSCallBackCode) {
    return this._http.post(this._baseUrl + 'api/CALPADS/CALPADSToken', codes)
      .map((response: ICALPADSToken) => response as ICALPADSToken)
      .catch(this.errorHandler);
  }

  getCALPADSDataTables(url: string) {
    return this._http.get<ICALPADSTables>(url)
      .map((response: ICALPADSTables) => response as ICALPADSTables)
      .catch(this.handleError);
  }

  getCALPADSDataTablesUat() {
    return this._http.get<ICALPADSTables>(`${this._baseUrl}api/CALPADS/GetCALPADSDataTablesUat`)
      .map((response: ICALPADSTables) => response as ICALPADSTables)
      .catch(this.handleError);
  }

  getCALPADSUploadedFiles(url: string): Observable<ICALPADSUploadedFileDetail[]> {
    return this._http.get<ICALPADSUploadedFileDetail[]>(url).map((response: ICALPADSUploadedFileDetail[]) => response as ICALPADSUploadedFileDetail[])
      .catch(this.handleError);
  }

  getSPEDErrorDetails(url: string): Observable<ICALPADSErrorDetailSPED[]> {
    return this._http.get<ICALPADSErrorDetailSPED[]>(url).map((response: ICALPADSErrorDetailSPED[]) => response as ICALPADSErrorDetailSPED[])
      .catch(this.handleError);
  }

  getSSRVErrorDetails(url: string): Observable<ICALPADSErrorDetailSSRV[]> {
    return this._http.get<ICALPADSErrorDetailSSRV[]>(url).map((response: ICALPADSErrorDetailSSRV[]) => response as ICALPADSErrorDetailSSRV[])
      .catch(this.handleError);
  }

  getUploadedFileStatusDetails(url: string): Observable<ICALPADSStatusDetail> {
    return this._http.get<ICALPADSStatusDetail>(url).map((response: ICALPADSStatusDetail) => response as ICALPADSStatusDetail)
      .catch(this.handleError);
  }

  insertUpdateCALPADSToken(CALPADSTokenDetails: ICALPADSToken) {
    return this._http.post(this._baseUrl + 'api/CALPADS/PostCALPADSToken', CALPADSTokenDetails)
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  uploadFile(uploadFile: ICALPADSUploadFile) {
    return this._http.post(this._baseUrl + 'api/CALPADS/PostTable', uploadFile)
      .map((response: ICALPADSUploadFileResponse) => response as ICALPADSUploadFileResponse)
      .catch(this.errorHandler);
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }

}
